import { FC, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import CustomCard from './Card-ui';
import { Project, Props, CardsData } from './CardsData';

const CardList: FC<Props> = ({ searchTerm, filter }) => {
  const [data, setData] = useState<Project[]>([]);
  useEffect(() => {
    const CardInfo: Project[] = CardsData;
    setData(CardInfo);
  }, []);
  const filterData = (
    info: Project[],
    searchBar: string,
    filterByTag: string,
  ): Project[] => {
    return info.filter(item => {
      if (filterByTag === 'all' && !searchBar) {
        return true;
      }
      if (
        searchBar &&
        !item.title.toLowerCase().includes(searchBar.toLowerCase())
      ) {
        return false;
      }
      if (
        filterByTag &&
        !item.tags.includes(filterByTag) &&
        filterByTag !== 'all'
      ) {
        return false;
      }
      return true;
    });
  };

  const filteredData = filterData(data, searchTerm, filter);

  return (
    <div className="card-list">
      <Grid container>
        <br />
        <br />
      </Grid>
      <Grid container spacing={6}>
        {filteredData.map(item => (
          <Grid item xs={8} sm={4} key={item.id}>
            <CustomCard data={item} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CardList;
